import http from "./httpService";
import auth from "./authService";

function supplierStoreUrl(id) {
  const pVisaId = localStorage.getItem("accountId");


  if (id) return `/v1/accounts/${pVisaId}/ledgers/${id}`;
  else return `/v1/accounts/${pVisaId}/ledgers`;
}

// export function getAllLedgers() {
//   return http.get(supplierStoreUrl());
// }

export function saveEntryType(supplier) {
  return http.post(`/v1/accounts-ledgers/${supplier.id}/update-entry-type`, supplier);
}

export function getAllLedgers(data) {
  const pVisaId = localStorage.getItem("accountId");
  return http.post(`/v1/accounts/${pVisaId}/generate-ledgers`, data);
}

export function deleteLedger(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function saveSingle(supplier) {
  return http.post(supplierStoreUrl(), supplier);
}

export function updateSingle(supplier) {
  return http.put(supplierStoreUrl(supplier.id), supplier);
}

// export function updateSingleStatus(supplier) {
//   return http.get(`/accounts/${supplier}/ledgers/${supplier.id}/status`);
// }

export function getLedger(supplierId) {
  return http.get(supplierStoreUrl(supplierId));
}
